import React, { Suspense } from 'react';
import McpLogin from 'features/auth/routes/McpLogin';
import { Loader } from '@urbantxt/loader';

/** Always reachable — even when Rosie session exists (required for MCP OAuth redirect return). */
const mcpLoginRoute = {
  path: '/mcp-login',
  element: (
    <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
      <McpLogin />
    </Suspense>
  ),
};

export default mcpLoginRoute;
